<template>
    <div v-if="stage" class="px-4">
        <v-row>
            <v-col>
                <v-select
                    v-model="modo"
                    :items="modes"
                    label="Modo de configuración"
                    item-text="text"
                    item-value="value"
                    outlined
                    dense
                    hide-details
                    @change="changedMode">
                </v-select>
            </v-col>
        </v-row>
        <v-row>
            <v-col v-if="modo == 'username'">
                <v-select
                    v-model="stage.username"
                    :items="available_users"
                    label="Usuario"
                    item-text="username"
                    item-value="username"
                    outlined
                    dense
                    hide-details
                ></v-select>
            </v-col>
            <v-col v-else>
                <v-card-text class="ml-0 pa-0 ma-0">
                    <label> Ruta al usuario: </label>
                </v-card-text>
                <RouteInBagSelectorComponent
                    v-model="stage.username_location"
                    :my_bag="my_bag"
                    outlined
                    hide-details="auto"
                    :error="showErrors && !stage.username_location"
                    @change="computeStage">
                </RouteInBagSelectorComponent>
            </v-col>
        </v-row>
        
    </div>
</template>

<script>
import { WaitForApproval } from '@/modules/document/domain/WorkflowTemplate';
import RouteInBagSelectorComponent from '@/modules/document/infra/RouteInBagSelectorComponent';
export default {
    name:'WaitForApprovalDetailComponent',
    components: {
        RouteInBagSelectorComponent
    },
    props:{
        stage: {
            type: WaitForApproval,
            default: false,
        },
        showErrors: {
            type: Boolean,
            default: false
        },
        available_types: {
            type: Array,
            default: () => []
        },
        my_bag: {
            type: Object,
            default: () => {}
        },
        available_users: {
            type: Array,
            default: () => []
        }
    },
    data(){
        return {
            modo: 'username',
            modes : [
                {value: 'username', text: 'Usuario fijo'},
                {value: 'username_location', text: 'Obtener del contexto'},
            ]
        }
    },
    mounted(){
        console.log(this.stage);
        if (this.stage.username_location) {
            this.modo = 'username_location';
        }
    },
    methods:{
        computeStage(){
            this.$emit('compute-stage');
        },
        changedMode(a){
            console.log(a);
            this.stage.username = ''
            this.stage.username_location = ''
            this.computeStage();
        }
    },
    computed:{
        
    },
}
</script>

<style scoped >
/*@import url('https://unpkg.com/json-schema-editor-vue@2.3.0/lib/json-schema-editor-vue.css');*/
.preaty__card {
    border-radius: 5px;
}
.small_scrollbar >>> textarea {
    scrollbar-width: thin;
}
.error--text {
    color: rgba(220, 11, 11, 0.898) !important;
}
</style>